<template>
  <div class="confirm-side-dialog">
    <slot name="modal-dialog">
      <modal-dialog
        v-bind:title="modalDialogLabel"
        with-cross
        width="100%"
        max-width="440px"
        v-model="isShowModalDialog"
      >
        <v-card-actions class="confirm-side-dialog__buttons">
          <button
            class="confirm-side-dialog__buttons__close"
            type="button"
            v-on:click="emitCancel">
            Нет
          </button>
          <button
            class="confirm-side-dialog__buttons__save"
            type="button"
            v-on:click="dispatchFormSubmit">
            Да, сохранить
          </button>
        </v-card-actions>
      </modal-dialog>
    </slot>
    <side-dialog
      v-bind:label="label"
      v-bind:size="size"
      v-on:cancel="onDialogCancel">
      <slot name="header" />
      <slot />
    </side-dialog>
    <button
      class="confirm-side-dialog__filler"
      type="button"
      v-on:click="onDialogCancel" />
  </div>
</template>
<script>
import ModalDialog from '@/components/ModalDialog.vue';
import SideDialog from '@/components/SideDialog.vue';

/**
 * @description Название события отмены.
 * @type {string}
 */
const NAME_EVENT_CANCEL = 'cancel';

/**
 * @description Компонент бокового диалога с подтверждением закрытия формы.
 * @type {Vue}
 */
export default {
  components: { SideDialog, ModalDialog },
  data() {
    return {
      /**
       * @description Показывать модальный диалог.
       * @type {boolean}
       */
      isShowModalDialog: false,
    };
  },
  methods: {
    /**
     * @description Отправить событие сохранения формы.
     * @returns {void}
     */
    dispatchFormSubmit() {
      this.isShowModalDialog = false;
      const [form] = this.$slots.default;
      if (form && form.elm instanceof HTMLFormElement) {
        this.$nextTick(() => {
          if (form.elm.reportValidity()) {
            const submitEvent = new SubmitEvent('submit', { cancelable: true });
            form.elm.dispatchEvent(submitEvent);
          }
        });
      }
    },
    /**
     * @description Отправить событие закрытия диалога.
     * @returns {void}
     */
    emitCancel() {
      this.isShowModalDialog = false;
      this.$emit(NAME_EVENT_CANCEL);
    },
    /**
     * @description Обработать закрытие диалога.
     * @returns {void}
     */
    onDialogCancel() {
      if (this.needConfirm === true) {
        this.isShowModalDialog = true;
      } else {
        this.emitCancel();
      }
    },
  },
  props: {
    /**
     * @description Текст заголовка диалога.
     * @type {string}
     */
    label: {
      required: true,
      type: String,
    },
    size: {
      required: false,
      type: String,
      default: 'normal',
    },
    /**
     * @description Требует подтверждения перед закрытием диалога.
     * @type {boolean}
     */
    needConfirm: {
      default: false,
      type: Boolean,
    },
    /**
     * @description Заголовок модального диалога.
     * @type {string}
     */
    modalDialogLabel: {
      default: 'Сохранить изменения?',
      type: String,
    },
  },
};
</script>
<style scoped lang="scss">
@use "@/scss/buttons";

.confirm-side-dialog {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  &__filler {
    background-color: #00000073;
    cursor: default;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    width: 300%;
    transform: translateX(-50%);
    pointer-events: all;
  }
  &__buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    grid-gap: 10px;
    &__close {
      min-width: 150px;
      @include buttons.btn-transparent(100%, 2.5rem, 1rem);
    }
    &__save {
      min-width: 150px;
      @include buttons.btn-blue(100%, 2.5rem, 1rem);
      white-space: nowrap;
    }
  }
}
@media screen and (max-width: 480px) {
  .confirm-side-dialog {
    &__buttons {
      grid-template-columns: 1fr;
    }
  }
}
</style>
